<div class="flex gap-4">
  <div class="flex-1 flex flex-col gap-4">
    <div class="flex items-end gap-2">
      <mat-form-field class="input-tg w-4/12" appearance="outline">
        <mat-label>Data</mat-label>
        <input matInput [matDatepicker]="dataPicker" [(ngModel)]="data" />
        <mat-datepicker-toggle matIconSuffix [for]="dataPicker"></mat-datepicker-toggle>
        <mat-datepicker #dataPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="input-tg w-3/12" appearance="outline">
        <mat-label>Estado</mat-label>
        <input matInput [(ngModel)]="estado" placeholder="SP, São Paulo..." />
      </mat-form-field>
      <button mat-flat-button class="btn-tg" [disabled]="loading" (click)="sugerirDia()">
        Sugerir pré-escala
      </button>
    </div>

    @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    @if (!loading && buscou && sugestoes.length === 0) {
    <div class="text-center text-gray-500 py-6">Nenhum serviço sem motorista nessa data.</div>
    }

    @if (sugestoes.length > 0) {
    <div class="flex justify-between items-center">
      <div class="text-sm text-gray-600">{{ sugestoes.length }} serviço(s), ordenados do maior valor pro menor.</div>
      <button mat-flat-button class="btn-tg" [disabled]="confirmando || totalSelecionados === 0"
        (click)="confirmarEscala()">
        @if (confirmando) {
        <mat-spinner diameter="20" class="loading-spinner"></mat-spinner>
        } @else {
        Confirmar escala ({{ totalSelecionados }})
        }
      </button>
    </div>

    <div class="flex flex-col gap-3">
      @for (sugestao of sugestoes; track sugestao.ordemServicoId) {
      <div class="border rounded p-3">
        <div class="flex justify-between items-start">
          <div>
            <div class="font-semibold">{{ sugestao.ordemServicoId }} — {{ sugestao.data }} {{ sugestao.horaInicio }}</div>
            <div class="text-sm text-gray-600">{{ sugestao.origem }} → {{ sugestao.destino }}</div>
          </div>
          <div class="flex items-center gap-2">
            <mat-chip-set>
              <mat-chip [matTooltip]="'Fonte da proximidade'">{{ sugestao.fonteProximidade }}</mat-chip>
            </mat-chip-set>
            <button mat-button (click)="toggleExpandir(sugestao)">
              {{ sugestao.expandido ? 'Ocultar candidatos' : 'Ver candidatos (' + sugestao.totalAvaliados + ')' }}
            </button>
          </div>
        </div>

        @if (sugestao.expandido) {
        <div class="mt-3">
          <mat-radio-group [(ngModel)]="sugestao.selecionadoMotoristaId" class="flex flex-col gap-2">
            @for (candidato of sugestao.candidatos; track candidato.motoristaId) {
            @if (candidato.elegivel) {
            <mat-radio-button [value]="candidato.motoristaId" class="border rounded p-2">
              <div class="flex flex-col">
                <span class="font-medium">{{ candidato.posicao }}º — {{ candidato.nome }}</span>
                @if (identificacaoCandidato(candidato); as identificacao) {
                <span class="text-xs text-gray-500">{{ identificacao }}</span>
                }
                <span class="text-xs text-gray-600">
                  Jornada prevista: {{ candidato.jornadaPrevistaHoras ?? '-' }}h (teto 14h) ·
                  Descanso: {{ candidato.descansoHoras ?? '-' }}h ·
                  Chegada em casa: {{ candidato.chegadaConfirmada ? 'confirmada no app' : 'estimada' }}
                  @if (candidato.distanciaKm != null) {
                  · {{ candidato.distanciaKm }} km da casa mais próxima
                  }
                  @if (candidato.avisoRodizio) {
                  · ⚠ {{ candidato.detalheRodizio }}
                  }
                </span>
              </div>
            </mat-radio-button>
            }
            }
          </mat-radio-group>

          @if (sugestao.totalAvaliados > sugestao.totalElegiveis) {
          <div class="mt-2">
            <div class="text-xs text-gray-500 mb-1">Excluídos:</div>
            @for (candidato of sugestao.candidatos; track candidato.motoristaId) {
            @if (!candidato.elegivel) {
            <div class="text-sm text-gray-400 line-through">
              {{ candidato.nome }} — {{ codigoExclusaoLabel[candidato.codigoExclusao] ?? candidato.codigoExclusao }}:
              {{ candidato.motivoExclusao }}
            </div>
            }
            }
          </div>
          }
        </div>
        } @else {
        <div class="text-sm mt-1">
          Sugerido: <b>{{ sugestao.motoristaSugerido ?? 'nenhum candidato elegível' }}</b>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>

  <div class="w-3/12 border rounded p-3 h-fit">
    <h4 class="mb-2">Valor acumulado no período</h4>
    @if (loadingResumo) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (resumoValor.length === 0) {
    <div class="text-sm text-gray-500">Sem serviços no período.</div>
    } @else {
    <div class="flex flex-col gap-2">
      @for (item of resumoValor; track item.motoristaId) {
      <div class="flex flex-col text-sm border-b pb-1">
        <span class="font-medium">{{ item.nome }}</span>
        <div class="flex justify-between text-gray-600">
          <span>{{ item.totalServicos }} serviço(s)</span>
          <span>{{ formatCurrency(item.valorServico) }}</span>
        </div>
      </div>
      }
    </div>
    }
  </div>
</div>
